import { registerLocale } from 'react-datepicker';
import svSE from 'date-fns/locale/sv';

const registered = new Set();

/**
 * Registers a Swedish date-fns locale variant whose week start matches organisation.first_weekday
 * (1=Monday … 7=Sunday, same encoding as Tools.getWeekStart).
 * @param {number} firstWeekday
 * @returns {string} Locale key to pass to react-datepicker's locale prop
 */
export function ensureSvScheduleLocale(firstWeekday) {
    const fw =
        Number.isFinite(Number(firstWeekday)) && firstWeekday >= 1 && firstWeekday <= 7
            ? Number(firstWeekday)
            : 1;
    const key = `sv-SE-fw-${fw}`;
    if (!registered.has(key)) {
        registered.add(key);
        const weekStartsOn = fw === 7 ? 0 : fw;
        registerLocale(key, {
            ...svSE,
            options: {
                ...svSE.options,
                weekStartsOn
            }
        });
    }
    return key;
}
